<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto;">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">预警配置</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form ref="form" :model="data" :rules="rules" label-width="16rem" style="width: 80%;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="报警类型" prop="AlertType">
                <el-select v-model="data.AlertType" :disabled="!IsEdit" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in AlertTypeArr"
                    :key="item.ItemKey"
                    :label="item.Description"
                    :value="item.Extend1"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="监测对象名" prop="ServiceMonitorObjectName">
                <el-input v-model="data.ServiceMonitorObjectName" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="服务地址" prop="ServiceInvokeUrl">
                <el-input v-model="data.ServiceInvokeUrl" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="服务请求方式" prop="ServiceHttpType">
                <el-select v-model="data.ServiceHttpType" disabled placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in ServiceHttpTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="服务监测频率" prop="ServiceMonitorFreqency">
                <el-input v-model="data.ServiceMonitorFreqency" disabled></el-input>
              </el-form-item>
            </el-col>
            <div style="padding-top:1rem;">
              <el-link type="primary" href="http://cron.qqe2.com/" disabled>Cron</el-link>
            </div>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="服务参数" prop="ServiceData">
                <el-input v-model="data.ServiceData" type="textarea" autosize disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="服务成功标记" prop="ServiceSucessFiled">
                <el-input v-model="data.ServiceSucessFiled" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务成功标记值" prop="ServiceSucessFiledValue">
                <el-input v-model="data.ServiceSucessFiledValue" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="服务返回值值域" prop="ServiceValueFiled">
                <el-input v-model="data.ServiceValueFiled" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务返回值是否列表" prop="ServiceResponseIsArray" label-width="17rem">
                <el-radio v-model="data.ServiceResponseIsArray" :label="1" disabled>是</el-radio>
                <el-radio v-model="data.ServiceResponseIsArray" :label="0" disabled>否</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="比对记录名称字段" prop="ApiNameField">
                <el-input v-model="data.ApiNameField" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="比对记录值字段" prop="ApiValueField">
                <el-input v-model="data.ApiValueField" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="比对记录值类型" prop="ApiValueFieldType">
                <el-select v-model="data.ApiValueFieldType" placeholder="请选择" disabled style="width: 100%;">
                  <el-option
                    v-for="item in ApiValueFieldTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="比较方式" prop="CompareType">
                <el-select v-model="data.CompareType" placeholder="请选择" disabled style="width: 100%;">
                  <el-option
                    v-for="item in CompareTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否开启预警" prop="EarlyWarningEnabled">
                <el-radio v-model="data.EarlyWarningEnabled" :label="1" :disabled="!IsEdit">是</el-radio>
                <el-radio v-model="data.EarlyWarningEnabled" :label="0" :disabled="!IsEdit">否</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预警阈值" prop="EarlyWarningValue">
                <el-input v-model="data.EarlyWarningValue" type="number" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否开启报警" prop="AlarmEnabled">
                <el-radio v-model="data.AlarmEnabled" :label="1" :disabled="!IsEdit">是</el-radio>
                <el-radio v-model="data.AlarmEnabled" :label="0" :disabled="!IsEdit">否</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报警阈值" prop="AlarmValue">
                <el-input v-model="data.AlarmValue" type="number" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="saveForm()" :disabled="!IsEdit" v-if="IsEdit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "ServiceConfigUserEdit",
  controller: "UI",
  action: "ServiceConfigUserEdit",
  data() {
    return {
      data: {
        AlertType: "",
        ServiceHttpType: "",
        ApiValueFieldType: "",
        CompareType: ""
      },
      AlertTypeArr: [],
      ServiceHttpTypeArr: [
        { value: "POST", label: "POST" },
        { value: "GET", label: "GET" }
      ],
      ApiValueFieldTypeArr: [
        { value: "number", label: "数值" },
        { value: "string", label: "字符串" }
      ],
      CompareTypeArr: [
        { value: ">", label: "大于" },
        { value: "=", label: "等于" },
        { value: "<", label: "小于" }
      ],
      IsEdit: false,
      rules: {
        AlertType: [
          { required: true, message: "请选择报警类型", trigger: "change" }
        ],
        ServiceMonitorObjectName: [
          { required: true, message: "请输入监测对象名", trigger: "blur" }
        ],
        ServiceInvokeUrl: [
          { required: true, message: "请输入服务地址", trigger: "blur" }
        ],
        ServiceHttpType: [
          { required: true, message: "请选择服务请求方式", trigger: "change" }
        ],
        ServiceMonitorFreqency: [
          { required: true, message: "请输入服务监测频率", trigger: "blur" }
        ],
        ServiceData: [
          { required: true, message: "请输入服务参数", trigger: "blur" }
        ],
        ServiceSucessFiled: [
          { required: true, message: "请输入服务成功标记", trigger: "blur" }
        ],
        ServiceSucessFiledValue: [
          { required: true, message: "请输入服务成功标记值", trigger: "blur" }
        ],
        ServiceValueFiled: [
          { required: true, message: "请输入服务返回值值域", trigger: "blur" }
        ],
        ServiceResponseIsArray: [
          {
            required: true,
            message: "请选择服务返回值是否列表",
            trigger: "change"
          }
        ],
        ApiNameField: [
          { required: true, message: "请输入比对记录名称字段", trigger: "blur" }
        ],
        ApiValueField: [
          { required: true, message: "请输入比对记录值字段", trigger: "blur" }
        ],
        ApiValueFieldType: [
          { required: true, message: "请选择比对记录值类型", trigger: "change" }
        ],
        CompareType: [
          { required: true, message: "请选择比较方式", trigger: "change" }
        ],
        EarlyWarningEnabled: [
          { required: true, message: "请选择是否开启预警", trigger: "change" }
        ],
        EarlyWarningValue: [
          { required: true, message: "请输入预警阈值", trigger: "blur" }
        ],
        AlarmEnabled: [
          { required: true, message: "请选择是否开启报警", trigger: "change" }
        ],
        AlarmValue: [
          { required: true, message: "请输入报警阈值", trigger: "blur" }
        ]
      },
      preValue: null,
      currentValue: null,
    };
  },
  created: function() {
    this.getAlarmType();
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted: function() {},
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    }
  },
  methods: {
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("AlarmSubsystem:AlarmType", "")
        .then(d => {
          this.AlertTypeArr = d.JValue;
        })
        .catch(e => console.error(e));
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          Id: InfoId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        new MyApis.TranResourcesApi()
          .GeItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            this.data = r;
            this.preValue = JSON.stringify(this.data);
          })
          .catch(e => {
            console.log(e);
              this.$message({
                  type: "error",
                  message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                });
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        const AlertName=this.AlertTypeArr.filter(item=>{return item.Extend1===this.data.AlertType});
        this.data.AlertName = AlertName[0].Description;

        let formAll = JSON.stringify(this.data);
        this.currentValue = formAll;
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateItem(formAll)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "预警信息修改";
            this.logInfo.LogMessage = "用户-预警信息修改成功";
            this.logInfo.ModuleName = "预警设置";
            this.logInfo.PageName = "预警配置-用户详情";
            this.logInfo.PreValue = this.preValue;
            this.logInfo.CurrentValue = this.currentValue;
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
              this.$message({
                  type: "error",
                  message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                });
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          Id: uuid
        };
        const AlertName=this.AlertTypeArr.filter(item=>{return item.Extend1===this.data.AlertType});
        this.data.AlertName = AlertName[0].Description;
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        this.currentValue = formAll;
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "预警信息添加";
            this.logInfo.LogMessage = "用户-预警信息添加成功";
            this.logInfo.ModuleName = "预警设置";
            this.logInfo.PageName = "预警配置-用户详情";
            this.logInfo.CurrentValue = this.currentValue;
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
              this.$message({
                  type: "error",
                  message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                });
          });
      }
    }
  }
};
</script>